import "./lib/closest-polyfill";
import "./components/breakUrls.js";
import "./components/fileUpload.js";

// import class components
import MainNav from "./components/MainNav";

// initialize components
document.addEventListener("DOMContentLoaded", () => {
  const mainNav = new MainNav();
});
